<template>
    <modal-dialog
        ref="forwardHandoverModal"
        label="Forward handover to user"
        description="Forward handover to user"
        :size="3"
    >
        <template #default="{ bindings }">
            <flex-container>
                <flex-container align-items="center">
                    <button-block-icon
                        :icon="ArrowTurnRightIcon"
                        :color="'turquoise-500'"
                        is-custom-icon
                    />
                    <div>
                        <text-heading>
                            Handover toewijzen
                        </text-heading>
                        <text-description>
                            Selecteer gebruiker om handover aan toe te wijzen
                        </text-description>
                    </div>
                </flex-container>
                <input-group v-model="forwardToUser">
                    <template #label>
                        Gebruiker:
                    </template>
                    <template #input>
                        <user-select-input
                            without-current-user
                        />
                    </template>
                </input-group>
                <flex-container align-items="center" justify-content="flex-end">
                    <button-text
                        :color="'black'"
                        @click="bindings.overlay.closeOverlay();"
                    >
                        Annuleren
                    </button-text>
                    <button-block
                        :color="'green-500'"
                        :disabled="!forwardToUser"
                        @loading="forwardHandover(bindings, $event)"
                    >
                        Toewijzen
                    </button-block>
                </flex-container>
            </flex-container>
        </template>
    </modal-dialog>
</template>

<script setup lang="ts">
    import { ref } from 'vue';
    import {
        ChatId,
        ReferHandoverCommand,
        User,
        UserId,
    } from '@keyvue/one-api-client';
    import {
        ButtonBlock,
        ButtonBlockIcon,
        ButtonState,
        type ButtonStateChangedEvent,
        ButtonText,
        FlexContainer,
        InputGroup,
        ModalDialog,
        TextDescription,
        TextHeading,
    } from '@keyvue/one-ui';
    import useClient from '@/services/keyvue-api/composables/useClient';
    import ArrowTurnRightIcon from '@keyvue/one-awesome-icons/icons/regular/arrow-turn-right.svg?component';
    import UserSelectInput from '@/company/user/components/input/UserSelectInput.vue';

    const props = defineProps<{ chatId: ChatId }>();
    const { client, currentUser } = useClient();

    const forwardHandoverModal = ref();
    const forwardToUser = ref<User | null>(null);

    async function forwardHandover(bindings: any, event: ButtonStateChangedEvent) {
        if (!forwardToUser.value) {
            return;
        }

        await client.dispatch(
            new ReferHandoverCommand(
                props.chatId,
                forwardToUser.value.id as UserId,
                currentUser.value.id,
            ),
        );

        bindings.overlay.closeOverlay();
        event.button.setState(ButtonState.completed);
    }

    defineExpose({
        overlay: forwardHandoverModal,
    });
</script>
